<template lang="pug">
  v-container(:fluid='isMobile').storefront
    main-carousel(:showCarousel="false" :category="category")
    v-container(style="height: 100%;").pt-0
      v-row.category-carousel
        v-icon mdi-sort-variant
        v-btn.mx-1(small text :class="$route.params.id === undefined ? 'category-carousel__item--active':'category-carousel__item'" @click="goTo()") Todas
        span(v-for="(cat, index) in categories")
          v-btn.mx-1(small text :class="category === cat ? 'category-carousel__item--active':'category-carousel__item'" @click="goTo(cat)") {{cat}}
      v-row.justify-center(v-if="loadingInput")
        v-skeleton-loader( max-width="300px" width='100%' type="list-item").mx-auto.my-2
      v-row.justify-center.mt-3(v-else)
        img(src="@/assets/images/location-icon.png")
        span.ml-2.video-card__location(v-if="txtAddress") {{txtAddress}}
        span.ml-2.video-card__location(v-else) No podemos acceder a tu ubicación
      v-row.justify-center.mt-3(v-if="!txtAddress && !loadingInput")
        .autocomplete-block(style='min-width: 250px;')
          gmap-autocomplete(@place_changed="setPlace" :value="address" :options="autocompleteOptions" placeholder="Introduce tu dirección").location-input
          v-btn(v-if="address" icon="" color="primary" @click="clearAutomplete")
            v-icon mdi-close
        v-btn(small color="#049d9f" @click="search()" :loading="searching").ml-2 Buscar
      v-row
        transition(name='slide-left' mode="out-in")
          // router-view(v-touch:swipe="swipeHandler" name='categoryViews' :key="category")
          StoreList(:category="category" :stores="stores")

</template>

<script>
  import Explore from '@/components/custom/Explore'
  import loaders from '@/plugins/mixins/loaders'
  import slide1 from '@/assets/images/slides/slide-1.png'
  import slide2 from '@/assets/images/slides/slide-2.png'
  import slide3 from '@/assets/images/slides/slide-3.png'
  import slide4 from '@/assets/images/slides/slide-4.png'
  import StoreList from '@/views/marketplace/StoreList'
  import * as vars from '@/vars.json'
  const geocoding = require('reverse-geocoding-google')
  export default {
    name: 'Home',

    components: {
      Explore,
      StoreList,
    },

    mixins: [loaders],

    data: () => ({
      // mainBg: require('@/assets/images/background-tender.png'),
      isMobile: false,
      transitionName: null,
      loadingInput: false,
      txtAddress: '',
      address: '',
      rangeShop: 5,
      searching: false,
      mainCategories: {},
      stores: [],
      slides: [
        { name: 'First', src: slide1 },
        { name: 'Second', src: slide2 },
        { name: 'Third', src: slide3 },
        { name: 'Fourth', src: slide4 },
      ],
      autocompleteOptions: {
        componentRestrictions: {
          country: [
            'co',
          ],
        },
      },
    }),

    computed: {
      category () {
        if (this.$route.params.id !== undefined) return this.$route.params.id.split('_').join(' ')
        return 'Todas'
      },
      categories () {
        return this.$store.getters['storefront/getCategories']
      },
      userAccessDirections () {
        if (this.$store.state.users.profile && this.$store.state.users.profile.defaultlocation) {
          // se inicio sesion y se tiene acceso a una direccion principal
          return true
        } else if (this.$store.state.users.profile && !this.$store.state.users.profile.defaultlocation) {
          // se inicio sesion pero no tiene direccion principal
          return false
        } else {
          // no hay usuario con sesion iniciada ( el acceso a la ubicacion se maneja en geolocate con la variable textAddress)
          return false
        }
      },
    },
    watch: {
      '$route' (to, from) {
        // // console.log(from, to);
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
        this.search()
      },
    },

    created () {
      const vm = this
      vm.loadingInput = true
      vm.loadMainCategories()
      vm.loadVirtualShops()
      vm.$store.dispatch('shops/getMainCategories', 'en').then(res => {
        if (res) {
          const categories = res.sort((a, b) => {
            if (a.data > b.data) {
              return 1
            }
            if (a.data < b.data) {
              return -1
            }
            return 0
          })
          vm.mainCategories = categories
          if (vm.userAccessDirections) {
            vm.loadingInput = false
            vm.location = vm.$store.state.users.profile.defaultlocation.location
            vm.txtAddress = vm.$store.state.users.profile.defaultlocation.direction
            vm.search()
          } else {
            vm.geolocate()
          }
        }
      })
    },

    mounted () {
      const vm = this
      vm.onResize()
    },

    methods: {
      geolocate () {
        const vm = this
        navigator.geolocation.getCurrentPosition(position => {
          // console.log(position)
          const latitude = position.coords.latitude
          const longitude = position.coords.longitude
          const config = {
            latitude: latitude,
            longitude: longitude,
            key: vars.googleKey,
          }
          vm.location = {
            lat: latitude,
            lng: longitude,
          }
          vm.search()
          geocoding.location(config, (err, data) => {
            if (err) {
              // console.log(err)
            } else {
              // console.log(data)
              vm.txtAddress = data.results[0].formatted_address
              vm.loadingInput = false
            }
          })
        })
        if (!vm.txtAddress) {
          vm.loadingInput = false
        }
      },
      setPlace (place) {
        // console.log(place)
        const vm = this
        vm.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        vm.location = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        vm.location = vm.center
        vm.address = place.formatted_address
        vm.search()
      },
      search () {
        const vm = this
        vm.$store.commit('storefront/SET_LOADING', true)
        vm.searching = true
        const data = {
          location: vm.location,
          distance: vm.rangeShop,
          category: vm.category !== 'Todas' ? vm.mainCategories.find(el => el.data === vm.category) : {},
        }
        vm.$store.dispatch('shops/getVirtualShopData', data).then(async res => {
          // console.log(res.data)
          vm.$store.commit('storefront/SET_LOADING', false)
          if (res.data) {
            vm.searching = false
            vm.stores = res.data.filter(el => el.data.status === 'active')
          }
        })
      },
      clearAutomplete () {
        const vm = this
        vm.address = ''
        // vm.location = ''
        // vm.search()
      },
      onResize () {
        this.isMobile = window.innerWidth < 1024
      },
      swipeHandler (dir) {
        const vm = this
        if (dir === 'left') vm.transitionName = 'slide-left'
        if (dir === 'right') vm.transitionName = 'slide-right'
      },
      goTo (route) {
        if (route) {
          const transformRoute = route.split(' ').join('_')
          this.$router.replace(`/store/${transformRoute}`)
        } else {
          this.$router.replace('/store/')
        }
      },
    },

  }
</script>
<style scoped lang="scss">
  /*.selected{*/
    /*border-bottom: 2px solid #008e95;*/
  /*}*/
  .autocomplete-block{
        padding: 0 1rem;
      // background-color: #bada55;
        display: flex;
        background:#f3f2f3;
        grid-template-columns: 40px max-content;
        align-items: center;
        border-radius: 5px;
        img{
          width: 100%;
        }
        .location-input{
          height: 100%;
          border: none;
          padding: 0 1rem;
          &:focus{
            outline: none !important;
          }
        }
      }
  .category-carousel{
    background: #bfbfbf;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    max-height: 50px;
    min-height: 50px;
    width: auto;
    overflow-y: hidden;
    overflow-x: auto;
    padding-left: 10px;
    padding-right: 10px;
    align-items:center;
    justify-content: space-between;
    padding-bottom: 0;
    &__item{
      margin: 0;
      background: #bfbfbf;
      &--active {
        margin: 0;
        color: #008e95;
        border-bottom: 2px solid #008e95;
        cursor: pointer;
      }
    }
  }
  .storefront{
    min-height: 100%;
    padding: 0;
    max-width: 100%;
    background-color: #fff;
    &__sheet{
      max-height: calc(100vh - 50px)
    }
  }
  .category-card{
    color: #fff;
    position:relative;
    overflow: hidden;
    border-radius: 5px;
    height: 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    p{
      margin:0;

    }
    &__content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      h3{
        line-height: 20px;
      }
      p{
        max-width: 90px !important;
        font-size: 7px !important;
      }
    }
    &__circle{
      z-index: -1;
      border-radius: 50%;
      width: 70px;
      height: 70px;
      position: absolute;
      right:-15px;
      bottom: -15px;
      display: flex;
      color: #fff;
      justify-content:center;
      align-items: center;
    }
    &.category{
      &__nacion{
        background-image: linear-gradient(to right, #009552, #00a955, #00a955, #00c362);
        .category-card__circle{
          background: #009850;
        }
      }
      &__deportes{
        background-image: linear-gradient(to right, #0046a6, #0046a6, #2b6dc7, #2b6dc7);
        .category-card__circle{
          background: #0046a6;
        }
      }
      &__viral{
        background-image: linear-gradient(to right, #de5c0c, #de5c0c, #e57e39, #e57e39);
        .category-card__circle{
          background: #dd5503;
        }
      }
      &__internacional{
        background-image: linear-gradient(to right, #6008ac, #6008ac, #802cc7, #802cc7);
        .category-card__circle{
          background: #56039b;
        }
      }
      &__vivir{
        background-image: linear-gradient(to right, #09a7ad, #09a7ad, #2cc2c7, #2cc2c7);
        .category-card__circle{
          background: #16999e;
        }
      }
      &__tecnologia{
        background-image: linear-gradient(to right, #aaaf0c, #aaaf0c, #c2c72c, #c2c72c);
        .category-card__circle{
          background: #878b06;
        }
      }
      &__eyn{
        background-image: linear-gradient(to right, #63a701, #63a701, #81c225, #81c225);
        .category-card__circle{
          background: #71af19;
        }
      }
      &__entretenimiento{
        background-image: linear-gradient(to right, #ad0988, #ad0988, #c2259f, #c2259f);
        .category-card__circle{
          background: #890c6d;
        }
      }
    }
  }
  .banner-title{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    h1 {
      color: #000;
      font-size: 3rem;

    }
    p{
      color :#000;
      font-size: 1.5rem;

    }
  }
</style>
